module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9556.2a3e3796.jpg";